var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-title-wrap"},[_c('div',{staticClass:"icon-title-inner"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),(_vm.info.src)?_c('b-img',{attrs:{"src":_vm.info.src,"fluid":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }